import { Component, OnDestroy, OnInit } from '@angular/core';
import { Account, Customer, CustomerAccount } from '@inyova/models';

import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as AppRootActions from '@app/app.actions';
import * as fromAppRoot from '@app/app.reducers';

import { TrackingService } from '@shared/services/tracking.service';

@Component({
  selector: 'app-dialog-tree-planted',
  templateUrl: './dialog-tree-planted.component.html',
  styleUrls: ['./dialog-tree-planted.component.scss'],
  standalone: false
})
export class DialogTreePlantedComponent implements OnInit, OnDestroy {
  protected readonly onDestroy$ = new Subject<void>();
  firstName: string;
  myReferalCustomer: string;
  closeModal = false;
  referralIncentiveMonths: number;
  referralIncentiveMoney: number;
  customer: Customer;
  currentAccount: Account;

  constructor(
    private store: Store,
    private trackingService: TrackingService
  ) {
    this.store.dispatch(AppRootActions.getPromotions());
  }

  ngOnInit(): void {
    this.store.pipe(select(fromAppRoot.selectCustomer), takeUntil(this.onDestroy$)).subscribe((customer) => {
      this.customer = customer;
      this.firstName = customer.first_name;
      this.myReferalCustomer = customer.total_referrals.my_referral_customer;
    });

    this.store.pipe(select(fromAppRoot.selectCurrentAccount), takeUntil(this.onDestroy$)).subscribe((value) => {
      this.currentAccount = value;
    });

    this.store.pipe(select(fromAppRoot.selectPromotions), takeUntil(this.onDestroy$)).subscribe((promotions) => {
      this.referralIncentiveMonths = promotions.meta.pending_rewards.months || 0;
      this.referralIncentiveMoney = promotions.meta.pending_rewards.money_overall || 0;
    });
  }

  close(): void {
    this.trackingService.trackActivity('[Button] Close tree planted dialog');
    document.cookie = 'seenReferral=;';
    this.closeModal = true;
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
